import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Cookies from "universal-cookie";
import styled from "styled-components";
import {
  Input,
  OutlineBtn,
  PasswordInput,
  message,
  notification,
  SuccessNotification,
  ErrorNotification,
} from "components/common";
import { callPostApi } from "utils/api";
// import LoginLogoImg from "assets/images/loginLogo.png";
import LoginLogoImg from "assets/images/v2/6.png";
import nuevaLogo from "assets/images/v2/logo-signup.svg";
import { saveStorage } from "utils/auth";
import { Spin } from "antd";
import Google2FAModal from "components/common/modals/Google2FAModal";

export default function LoginPage() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    country: "",
  });
  const [isUpdating, setIsUpdating] = useState(false);
  let sudoName = undefined;
  let pathName = undefined;
  const [isShowForgotPwdForm, setIsShowForgotPwdForm] = useState(false);
  const [isSendingUsername, setIsSendingUsername] = useState(false);
  const [faModal, setFaModal] = useState(false);
  const [is2FALoading, setIs2FALoading] = useState(false);
  const [loginMode, setLoginMode] = useState("login") // login, token-login, sudo-token-login
  const [userId, setUserId] = useState("");

  const onFormInput = (field, value) => {
    setFormData({
      ...formData,
      [field]: value,
    });
  };

  const onLoginSuccess = (res) => {
    if (!res.data.required_2fa) {
      const cookies = new Cookies();
      const popUp = cookies.get("popUp");
      if (popUp && res?.data?.popup?.id) {
        if (res?.data?.popup?.id !== popUp.id) {
          cookies.set(
            "popUp",
            { ...res.data.popup, isNew: 1 },
            { path: "/", maxAge: 2592000 }
          );
        } else {
          cookies.set(
            "popUp",
            { ...popUp, isNew: 2 },
            { path: "/", maxAge: 2592000 }
          );
        }
      } else {
        if (res?.data?.popup?.id) {
          cookies.set(
            "popUp",
            { ...res.data.popup, isNew: 1 },
            { path: "/", maxAge: 2592000 }
          );
        }
      }
      saveStorage(res.data.user, res.data.token, sudoName);
      dispatch({
        type: "auth.SET_USER",
        payload: {
          user: res.data.user,
          sudoName: sudoName,
        },
      });
      dispatch({
        type: "auth.CHECK_HOLD",
      });
      setIsUpdating(false);
      setTimeout(() => {
        history.push(pathName ? pathName : "/");
      }, 1500);
    } else {
      setFaModal(true);
      setUserId(res.data.user_id);
    }
  };
  
  const onLoginFailure = (errorMsg) => {
    setIsUpdating(false);
    ErrorNotification("Invalid username or password");
    history.push("/login");
  };
  const handleSubmit = () => {
    // Check validation
    if (!formData.username || !formData.password) {
      message.error("Please input username and password");
      return;
    }
    if (!formData.country) {
      console.log("Invalid Country");
      return;
    }

    setIsUpdating(true);
    callPostApi(
      "auth/login",
      {
        username: formData.username.toLowerCase().trim(),
        password: formData.password,
        country: formData.country,
      },
      onLoginSuccess,
      onLoginFailure
    );
  };

  const onSuccessSentUsername = ({ message }) => {
    setIsSendingUsername(false);
    SuccessNotification(message);
  };

  const onFailedSendUsername = () => {
    setIsSendingUsername(false);
  };

  const handleSendUsername = () => {
    if (!formData.username.trim()) {
      ErrorNotification("Please input your username");
      return;
    }
    setIsSendingUsername(true);
    callPostApi(
      "auth/forgot_password",
      { username: formData.username },
      onSuccessSentUsername,
      onFailedSendUsername
    );
  };

  const handleCancelSendUsername = () => {
    setIsSendingUsername(false);
    setIsShowForgotPwdForm(false);
  };

  const loadUserCountry = () => {
    fetch("https://api.mydailychoice.com/location")
      .then((res) => res.json())
      .then((res) => {
        onFormInput(
          "country",
          res.countryCode === "RS" ? "US" : res.countryCode
        );
      })
      .catch((data, status) => {
        console.log("Invalid Country.");
      });
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.has("auto-token-login")) {
      // Auto-Token Login
      const token = params.get("token");
      sudoName = params.get("sudoName");
      pathName = params.get("pathName");
      callPostApi(
        "auth/login/token",
        { token },
        onLoginSuccess,
        onLoginFailure
      );
    }
    if (params.has("autologin")) {
      // Auto Login by Encrypted Username Password pair
      // It comes from Corp Checkout Result page
      const username = params.get("autologin");
      const password = atob(params.get("token"));
      const formData0 = {
        username: username.toLowerCase().trim(),
        password: password,
      };
      setIsUpdating(true);
      callPostApi("auth/login", formData0, onLoginSuccess, onLoginFailure);
    }
  }, []);
  const handle2faSubmit = (code) => {
    // event.preventDefault();
    // Check validation

    setIs2FALoading(true);
    if (loginMode == "login")
      callPostApi(
        "auth/2fa_login",
        {
          user_id: userId,
          username: formData.username.toLowerCase().trim(),
          password: formData.password,
          country: formData.country,
          code: code
        },
        onLoginSuccess,
        on2FALoginFailure
      );
    else if (loginMode == "token-login") {
      const params = new URLSearchParams(window.location.search);
      const token = params.get("token");
      callPostApi(
        "auth/2fa_login/token",
        { token, code },
        onLoginSuccess,
        on2FALoginFailure
      );
    }
  }


  const on2FALoginFailure = (errorMsg) => {
    setIsUpdating(false);
    ErrorNotification("Invalid 2FA Code");
  };

  useEffect(() => {
    localStorage.removeItem("modalShownAfterLogin");
    const params = new URLSearchParams(window.location.search);
    if (params.has("auto-token-login")) {
      // Auto-Token Login
      const token = params.get("token");
      const sudoToken = params.get("sudoToken");
      setLoginMode("token-login")
      sudoName = params.get('sudoName');
      pathName = params.get('pathName');
      callPostApi(
        "auth/login/token",
        { token, sudoToken },
        onLoginSuccess,
        onLoginFailure
      );
    }
    if (params.has("autologin")) {
      // Auto Login by Encrypted Username Password pair
      // It comes from Corp Checkout Result page
      const username = params.get("autologin");
      const password = atob(params.get("token"));
      const formData0 = {
        username: username.toLowerCase().trim(),
        password: password,
      };
      setIsUpdating(true);
      callPostApi("auth/login", formData0, onLoginSuccess, onLoginFailure);
    }
  }, []);


  useEffect(() => {
    loadUserCountry();
  }, []);

  return (
    <Wrapper>
      {/* <div className="mobile-screen-logo">
        <img src={LoginLogoImg} alt="left-bg" />
      </div>
      {isShowForgotPwdForm ? (
        <div className="form-root">
          <div className="please-text">
            Please enter your username or email.
          </div>
          <div className="form-group">
            <div className="field-label">
              <div className="label-text">Email or Username</div>
            </div>
            <Input
              value={formData.username}
              onChange={(e) => onFormInput("username", e.target.value)}
              placeholder={"Enter your email or username"}
              className="username"
            />
          </div>
          <div className="action-group reset-pwd">
            <OutlineBtn
              className={"submit-btn"}
              loading={isSendingUsername}
              onClick={handleSendUsername}
            >
              Send
            </OutlineBtn>
            <OutlineBtn
              className={"submit-btn cancel"}
              onClick={handleCancelSendUsername}
            >
              Cancel
            </OutlineBtn>
          </div>
        </div>
      ) : (
        <div className="form-root">
          <div className="welcome-text">Welcome to Nueva! 👋</div>
          <div className="please-text">
            Please enter your Nueva username and password to login to your
            account.
          </div>
          <div className="form-group">
            <div className="field-label">
              <div className="label-text">Email or Username</div>
            </div>
            <Input
              value={formData.username}
              onChange={(e) => onFormInput("username", e.target.value)}
              placeholder={"Enter your username"}
              className="username"
            />
          </div>
          <div className="form-group">
            <div className="field-label">
              <div className="label-text">Password</div>
              <div
                className="forgot-text"
                onClick={() => setIsShowForgotPwdForm(true)}
              >
                Forgot Password?
              </div>
            </div>
            <PasswordInput
              value={formData.password}
              onChange={(e) => onFormInput("password", e.target.value)}
              onPressEnter={handleSubmit}
              placeholder={"Enter your password"}
              className="password"
            />
          </div>
          <div className="action-group">
            <OutlineBtn
              className={"submit-btn"}
              loading={isUpdating}
              onClick={handleSubmit}
            >
              Login
            </OutlineBtn>
          </div>
        </div>
      )} */}

      <section className="signup">
        <div className="signup__form">
          <div className="logo">
            <a href="/">
              <img src={nuevaLogo} alt="Logo" />
            </a>
          </div>
          {isShowForgotPwdForm ? (
            <div className="form">
              <h2 className="title">Forgot Password</h2>

              <div className="input-form-section">
                <div className="input field-input-section">
                  <label>Email or Username</label>
                  <input
                    type="text"
                    value={formData.username}
                    onChange={(e) => onFormInput("username", e.target.value)}
                    placeholder={"Enter your email or username"}
                  />
                </div>
              </div>

              <div className="btn send-cancel-btn">
                <Spin
                  spinning={isSendingUsername}
                  className="logo-spinner"
                  onClick={handleSendUsername}
                >
                  <button className="btn__primary">Send</button>
                </Spin>
                <Spin
                  spinning={false}
                  className="logo-spinner"
                  onClick={handleCancelSendUsername}
                >
                  <button className="btn__primary">Cancel</button>
                </Spin>
              </div>
            </div>
          ) : (
            <div className="form">
              <h2 className="title">Login</h2>

              <div className="input-form-section">
                <div className="input field-input-section">
                  <label>Email or Username</label>
                  <input
                    type="text"
                    value={formData.username}
                    onChange={(e) => onFormInput("username", e.target.value)}
                    placeholder={"Enter your username"}
                  />
                </div>
                <div className="input field-input-section">
                  <label>Password</label>
                  <input
                    type="password"
                    value={formData.password}
                    onChange={(e) => onFormInput("password", e.target.value)}
                    onPressEnter={handleSubmit}
                    placeholder={"Enter your password"}
                  />
                </div>
              </div>
              <div
                onClick={() => setIsShowForgotPwdForm(true)}
                className="forgot-text"
              >
                Forgot Password?
              </div>
              <div className="btn">
                <Spin
                  spinning={isUpdating}
                  className="logo-spinner"
                  onClick={handleSubmit}
                >
                  <button disabled={isUpdating} className="btn__primary">
                    Login
                  </button>
                </Spin>
              </div>
            </div>
          )}
        </div>
        <div className="signup__bg">
          <img src={LoginLogoImg} alt="Background" />
        </div>
      </section>
      <Google2FAModal
        visible={faModal}
        onCancel={() => setFaModal(false)}
        onSubmit={handle2faSubmit}
        isLoading={is2FALoading}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  /* new code  */
  font-family: Gotham, sans-serif !important;
  @keyframes borderAnimation {
    to {
      transform: translate(-50%, -50%) rotate(1turn);
    }
  }
  .signup {
    align-items: center;
    display: grid;
    grid-template-columns: 1fr 1fr;
    min-height: 100vh;
  }
  @media (max-width: 768px) {
    .signup {
      grid-template-columns: auto;
    }
  }
  .signup__form {
    display: flex;
    flex-direction: column;
    height: 100%;
    /* justify-content: center; */
    padding: clamp(24px, 4.319vw + 7.8px, 70px)
      clamp(50px, 12.009vw + 1.46px, 300px);
    background-color: #fff;
  }
  .signup__form .logo {
    align-items: center;
    display: flex;
    margin-bottom: clamp(24px, 4.319vw + 7.8px, 70px);
  }
  .signup__form .form .title {
    color: #5c6151;
    font-family: Gotham, sans-serif;
    font-size: clamp(20px, 1.127vw + 15.77px, 32px);
    font-weight: 400;
    margin-bottom: clamp(20px, 2.347vw + 11.2px, 45px);
    margin-top: clamp(20px, 2.16vw + 11.9px, 43px);
    text-align: center;
    text-transform: capitalize;
  }
  .signup__form .form label {
    color: #595959;
    display: inline-block;
    font-size: clamp(14px, 0.376vw + 12.59px, 18px);
    font-weight: 500;
    line-height: 1.5;
    margin-bottom: clamp(6px, 1.315vw + 1.07px, 20px);
    position: relative;
    text-transform: capitalize;
  }
  .signup__form .form label:after {
    color: #37c3b8;
    content: "*";
    position: absolute;
    right: -10px;
    top: 0;
  }
  .signup__form .form input {
    border: 1px solid var(--color-base-dimgray, #5c6151);
    border-radius: 4px;
    height: clamp(40px, 1.127vw + 35.77px, 52px);
    outline: none;
    padding: 12px;
  }
  .signup__form .form .btn,
  .signup__form .form input {
    margin-bottom: clamp(8px, 1.502vw + 2.37px, 24px);
    width: 100%;
  }
  .signup__form .form .btn {
    max-width: 100%;
  }
  .signup__form .form .btn__primary {
    color: #fff;
  }
  .signup__form .form p {
    color: #5c6151;
    font-size: 14px;
    text-align: center;
  }
  .signup__form .form p span {
    display: block;
  }
  .signup__form .form p a {
    color: #37c3b8;
  }
  .signup__bg {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    position: relative;
  }
  @media (max-width: 768px) {
    .signup__bg {
      display: none;
    }
  }
  .signup__bg img {
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
    -o-object-position: center top;
    object-position: center top;
    position: absolute;
    width: 100%;
  }

  .signup-form-error {
    color: red !important;
    text-align: start !important;
    margin: 0px 0 -7px;
    position: relative;
    top: -18px;
  }
  .checked-signup[type="checkbox"]:checked {
    accent-color: #0abab5;
  }
  .ant-spin-dot-item {
    background-color: #0abab5 !important;
  }
  .btn {
    max-width: -moz-max-content;
    max-width: max-content;
    position: relative;
  }
  .btn,
  .btn__gradient,
  .btn__primary {
    border-radius: 35px;
    overflow: hidden;
  }
  .btn__gradient,
  .btn__primary {
    height: 100%;
    width: 100%;
    z-index: 0;
  }
  .btn__gradient:before,
  .btn__primary:before {
    animation: borderAnimation 5s linear infinite;
    background-image: conic-gradient(
      rgba(55, 195, 184, 0) 52.44%,
      rgba(55, 195, 184, 0.7) 106.23%
    );
    background-position: 0 0;
    background-repeat: no-repeat;
    content: "";
    height: 999px;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%) rotate(0deg);
    width: 999px;
    z-index: -2;
  }
  .btn__primary {
    align-items: center;
    background-color: transparent;
    border: 0;
    color: #1c1c1c;
    cursor: pointer;
    display: flex;
    font-size: clamp(13px, 0.321vw + 11.85px, 18px);
    font-weight: 500;
    justify-content: center;
    line-height: 1.55;
    outline: none;
    padding: clamp(12px, 0.513vw + 10.15px, 20px)
      clamp(18px, 0.897vw + 14.77px, 32px);
    position: relative;
    text-transform: uppercase;
    z-index: 1;
  }
  .btn__primary.btn_transparent:after {
    background-color: #fff;
    border: 1px solid hsla(0, 0%, 76%, 0.361);
  }
  .btn__primary:after {
    background-color: #0abab5;
    border-radius: 35px;
    content: "";
    height: calc(100% - 5px);
    left: 2px;
    position: absolute;
    top: 2px;
    width: calc(100% - 5px);
    z-index: -2;
  }
  .forgot-text {
    color: #0099ff;
    text-align: right;
    cursor: pointer;
    font-size: 16px;
    margin-bottom: 10px;
  }
  .send-cancel-btn {
    display: flex;
    justify-content: end;
    align-items: center;
  }
  /* new code  */

  /* padding: 2rem !important;
  width: calc(100% - 100px);

  img {
    height: 80px;
    margin: 0 auto;
    display: flex;
  }
  .form-group {
    margin: 24px 0;
    .ant-input-affix-wrapper {
      border-color: #d8d6de;
      border-radius: 0.357rem;
    }
    .ant-input {
      border-color: #d8d6de;
      border-radius: 0.357rem;
    }
  }
  .username {
    height: 40px;
  }
  .password {
    height: 40px;
  }
  .submit-btn {
    width: 100%;
    height: 38px;
  }
  .welcome-text {
    font-size: 28px;
  }
  .please-text {
    color: #6e6b7b;
    margin-top: 7px;
    font-size: 14px;
  }
  .field-label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 2px;
    .label-text {
      font-size: 0.857rem;
      color: #6e6b7bc2;
    }
    .forgot-text {
      font-size: 0.857rem;
      color: #00b2ff;
      cursor: pointer;
    }
  }
  .action-group {
    button {
      border-radius: 0.357rem !important;
      background: #00b2ff !important;
      color: white !important;
    }
  }
  .action-group.reset-pwd {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .submit-btn.cancel {
      margin-left: 20px;
    }
  }
  .mobile-screen-logo {
    width: 130px;
    position: absolute;
    top: 30px;
    left: 40px;
    display: none;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  @media (max-width: 1000px) {
    .mobile-screen-logo {
      display: block;
    }
  }
  @media (max-width: 1360px) {
    padding: 0px !important;
    width: calc(100% - 80px);
    .welcome-text {
      font-size: 18px;
    }
    .please-text {
      font-size: 13px;
    }
  }
  @media (max-width: 1360px) {
    width: 60%;
  }

  @media (max-width: 600px) {
    width: 80%;
  } */
`;
